import isServerSide from '@helpers/misc/isServerSide'

export default function isMobile() {
  if (isServerSide()) return false
  return typeof window.orientation !== 'undefined'
}
